(()=>{'use strict';
  // El cajón vive en la sección estática tdm-carrito como <tdm-cart-drawer>. bindCart() engancha una
  // instancia del motor a un nodo raíz; si el editor de temas re-renderiza la sección, el nuevo nodo se
  // engancha solo (connectedCallback) y la instancia vieja queda inerte porque su raíz ya no está conectada.
  function bindCart(raiz){
  if(!raiz||raiz.dataset.smcListo)return;
  raiz.dataset.smcListo='1';
  const alive=()=>raiz.isConnected;

  const $=(s,r=raiz)=>r.querySelector(s), $$=(s,r=raiz)=>Array.from(r.querySelectorAll(s));
  const rootPath=()=>window.Shopify?.routes?.root||'/';
  const route=p=>`${rootPath()}${String(p).replace(/^\//,'')}`;
  const panel=$('.smc-panel'),lineas=$('[data-smc-lineas]'),totales=$('[data-smc-totales]'),globo=$('[data-smc-globo]');
  const ahorro=$('[data-smc-ahorro]'),ahorroTxt=$('[data-smc-ahorro-txt]'),envioTxt=$('[data-smc-envio-txt]'),barra=$('[data-smc-barra]');
  const cta=$('[data-smc-cta]'),estado=$('[data-smc-estado]'),errorEl=$('[data-smc-error]'),envio=$('[data-smc-envio]');
  // Escalones de beneficio, tarjeta del siguiente escalón y envío protegido (2026-09-10).
  // Los tres son opcionales: si la sección no los emite, las referencias quedan en null y todo sigue igual.
  const escalones=$('[data-smc-escalones]'),escBarra=$('[data-smc-esc-barra]'),escFalta=$('[data-smc-esc-falta-txt]');
  const nextCaja=$('[data-smc-next]'),nextTitulo=$('[data-smc-next-titulo-txt]'),nextSub=$('[data-smc-next-sub-txt]'),nextBtn=$('[data-smc-next-cta-btn]'),nextUnit=$('[data-smc-next-unit-txt]');
  const prot=$('[data-smc-prot]'),protPrecio=$('[data-smc-prot-precio-txt]'),protSw=$('[data-smc-prot-toggle]');
  const extras=$('[data-smc-extras]'),regalo=$('.smc-regalo');
  const UMBRAL=Math.max(0,Number(raiz.dataset.smcUmbral)||0),MENOS=raiz.dataset.smcMenos||'',MAS=raiz.dataset.smcMas||'',SHIPPING_FREE=raiz.dataset.smcShippingFree??'Felicitaciones, tenés envío gratis solo por hoy',SHIPPING_PENDING=raiz.dataset.smcShippingPending??'Te faltan [MONTO] para tener envío GRATIS',SAVINGS=raiz.dataset.smcSavings??'Estás ahorrando [MONTO] en tu pedido',EMPTY=raiz.dataset.smcEmpty??'Tu carrito está vacío.',LABEL_DISCOUNT=raiz.dataset.smcLabelDiscount??'Descuento',LABEL_TOTAL=raiz.dataset.smcLabelTotal??'Total'; // ?? y no ||: un texto borrado en el editor queda vacío en vez de volver al predeterminado
  const TIERS=(()=>{
    try{
      const lista=JSON.parse(raiz.dataset.smcTiers||'[]');
      return (Array.isArray(lista)?lista:[])
        .map(t=>({qty:Math.max(0,Math.floor(Number(t?.qty)||0)),label:String(t?.label??''),sub:String(t?.sub??''),totalCents:Math.max(0,Math.round(Number(t?.totalCents)||0))}))
        .filter(t=>t.qty>0).sort((a,b)=>a.qty-b.qty);
    }catch(e){console.warn('[TDM cart escalones]',e);return[]}
  })();
  const ESC_FALTA=raiz.dataset.smcEscFalta??'',ESC_COMPLETO=raiz.dataset.smcEscCompleto??'';
  const NEXT_TITULO=raiz.dataset.smcNextTitulo??'',NEXT_SUB=raiz.dataset.smcNextSub??'',NEXT_CTA=raiz.dataset.smcNextCta??'',NEXT_UNIT=raiz.dataset.smcNextUnit??'';
  const PROT_VARIANT=Math.max(0,Number(raiz.dataset.smcProtVariante)||0),PROT_PRODUCT=Math.max(0,Number(raiz.dataset.smcProtProducto)||0),PROT_PRICE=Math.max(0,Math.round(Number(raiz.dataset.smcProtPrecio)||0));
  // Los iconos de cantidad van en línea (antes eran dos .svg de asset) para poder pintarlos con
  // currentColor: restar en rojo, sumar en verde, ambos editables desde el editor de temas.
  const SVG_MENOS='<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="currentColor"/><rect x="5.5" y="9" width="9" height="2" rx="1" fill="#fff"/></svg>';
  const SVG_MAS='<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="currentColor"/><rect x="5.5" y="9" width="9" height="2" rx="1" fill="#fff"/><rect x="9" y="5.5" width="2" height="9" rx="1" fill="#fff"/></svg>';
  const CACHE_TTL=2500,DEBOUNCE_QTY=70,DISCOUNT_RECONCILE_MS=90;
  const state={cart:null,confirmedCart:null,fetchedAt:0,desired:new Map(),removing:new Set(),draining:false,drainTimer:0,lastFocus:null,scrollY:0,readSeq:0,mutationRevision:0,refreshController:null,pendingOps:0,checkoutBlocked:false,economics:null,economicsRequired:false,paintedSig:null,slide:null,settled:false};
  const removalControlLocks=new WeakMap();
  let mutationChain=Promise.resolve();

  const miles=n=>String(Math.max(0,Math.round(n))).replace(/\B(?=(\d{3})+(?!\d))/g,'.');
  // Display whole pesos; calculations and Shopify validation continue using cents.
  const corto=c=>'$'+miles((Number(c)||0)/100);
  const largo=c=>corto(Math.abs(Number(c)||0));
  const conMoneda=c=>corto(c)+' ARS';
  const sinSigno=c=>miles((Number(c)||0)/100)+' ARS';
  // Precio por unidad: la comparación que realmente hace el cliente cuando decide un pack.
  const unitario=(totalCents,qty)=>corto((Number(totalCents)||0)/Math.max(1,Number(qty)||1));
  const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const stableObject=o=>Object.keys(o||{}).sort().map(k=>`${k}:${String(o[k])}`).join('|');
  const identity=it=>`${Number(it?.variant_id)||0}::${stableObject(it?.properties||{})}::${Number(it?.selling_plan_allocation?.selling_plan?.id)||0}`;
  const merchandiseTotal=cart=>window.DERMOVACartPricing?.merchandiseTotal?.(cart)??(Number(cart?.total_price)||0);
  const discountCents=cart=>Math.max(0,Number(cart?.total_discount)||((Number(cart?.original_total_price)||0)-merchandiseTotal(cart)));
  // El seguro de envío es un producto de servicio: cuenta para el total pero NO es una unidad del pedido
  // ni se dibuja entre los productos. Se representa solo con el interruptor del pie.
  const esProt=it=>(PROT_VARIANT>0&&Number(it?.variant_id)===PROT_VARIANT)||(PROT_PRODUCT>0&&Number(it?.product_id)===PROT_PRODUCT);
  const lineasCliente=cart=>(cart?.items||[]).filter(it=>!esProt(it));
  const unidadesCliente=cart=>lineasCliente(cart).reduce((n,it)=>n+Math.max(0,Number(it.quantity)||0),0);
  const totalCliente=cart=>lineasCliente(cart).reduce((n,it)=>n+(Number(it.final_line_price)||0),0);
  function shippingStatus(cart){
    const protection=(cart?.items||[]).filter(esProt).reduce((sum,it)=>sum+Math.max(0,Number(it.final_line_price)||0),0);
    const amount=Math.max(0,Math.min(totalCliente(cart),merchandiseTotal(cart)-protection));
    const hasItems=unidadesCliente(cart)>0;
    return{hasItems,amount,free:hasItems&&(UMBRAL<=0||amount>=UMBRAL),missing:Math.max(0,UMBRAL-amount)};
  }
  // PIES uses real units on its base SKU; legacy pack variants retain their original meaning.
  // Neither participates in CLEAR's separate quantity ladder or its quantity upsell.
  // IDs also cover native quick-add/cart links that omit our private pack properties.
  const PIES_PRODUCT=10683699134757,PIES_VARIANTS=new Set([53904624812325,53904624845093,53904624877861]);
  const esPackPies=it=>Number(it?.product_id)===PIES_PRODUCT||PIES_VARIANTS.has(Number(it?.variant_id||it?.id))||Number(it?.properties?._tdm_master_product_id)===PIES_PRODUCT||Number(it?.properties?._dermova_pack_units)>0;
  const esClear=it=>Number(it?.product_id)===10525766549797||Number(it?.variant_id||it?.id)===52678402539813||Number(it?.properties?._tdm_master_product_id)===10525766549797;
  const esPeel=it=>Number(it?.product_id)===10693763531045||Number(it?.variant_id||it?.id)===53949689594149||Number(it?.properties?._tdm_master_product_id)===10693763531045;
  const lineasEscalera=cart=>lineasCliente(cart).filter(it=>!esPackPies(it)&&!esPeel(it));
  const unidadesEscalera=cart=>lineasEscalera(cart).reduce((n,it)=>n+Math.max(0,Number(it.quantity)||0),0);
  const totalEscalera=cart=>lineasEscalera(cart).reduce((n,it)=>n+(Number(it.final_line_price)||0),0);
  const lineaProt=cart=>(cart?.items||[]).find(esProt)||null;
  const tierSiguiente=qty=>TIERS.find(t=>qty<t.qty)||null;
  const majorToCents=v=>Math.round((Number(v)||0)*100);
  function cartFromSectionHTML(html){
    if(typeof html!=='string'||!html)return null;const m=html.match(/<script[^>]*data-tdm-cart-state[^>]*>([\s\S]*?)<\/script>/i);if(!m)return null;
    try{const cart=JSON.parse(m[1]);return cart&&Array.isArray(cart.items)?cart:null}catch{return null}
  }
  function cartFromAddResponse(response){return cartFromSectionHTML(response?.sections?.['cart-drawer-section'])}
  function cartFromStandardResult(result){
    const items=result?.detail?.items;if(!Array.isArray(items)||!result?.cart)return null;
    // Native grand totals do not prove how shipping and order discounts were allocated.
    // DERMOVA always confirms this secondary event through Ajax's complete cart breakdown.
    if(window.DERMOVACartPricing?.requires?.({items}))return null;
    const total=majorToCents(result.cart?.cost?.totalAmount?.amount),original=items.reduce((n,it)=>n+(Number(it.original_line_price)||Number(it.final_line_price)||0),0);
    const subtotal=items.reduce((n,it)=>n+(Number(it.final_line_price)||0),0);
    // If the native event includes delivery/tax/order discounts, fetch Ajax's full breakdown.
    if(!Number.isFinite(total)||Math.abs(total-subtotal)>1)return null;
    return{items,item_count:Number(result.cart.totalQuantity)||items.reduce((n,it)=>n+(Number(it.quantity)||0),0),total_price:total,items_subtotal_price:subtotal,original_total_price:original,total_discount:Math.max(0,original-subtotal),currency:result.cart?.cost?.totalAmount?.currencyCode||window.Shopify?.currency?.active||'ARS'};
  }
  const fresh=()=>state.cart&&(Date.now()-state.fetchedAt)<CACHE_TTL;
  function quantityRule(it){
    const q=it?.quantity_rule||{};
    const min=Math.max(1,Number(q.min)||1),increment=Math.max(1,Number(q.increment)||1);
    const rawMax=Number(q.max)||0,max=rawMax>0?Math.max(min,rawMax):0;
    return{min,increment,max};
  }
  function normalizeQty(qty,it){
    qty=Math.max(0,Math.floor(Number(qty)||0));if(qty===0)return 0;
    const r=quantityRule(it);let out=Math.max(r.min,qty);
    out=r.min+Math.round((out-r.min)/r.increment)*r.increment;
    if(r.max>0){const last=r.min+Math.floor((r.max-r.min)/r.increment)*r.increment;out=Math.min(out,last)}
    return Math.max(r.min,out);
  }

  function announce(msg){if(estado){estado.textContent='';requestAnimationFrame(()=>{estado.textContent=String(msg||'')})}}
  function showError(msg){if(!errorEl)return;errorEl.textContent=String(msg||'No pudimos actualizar el carrito.');errorEl.hidden=false;announce(errorEl.textContent)}
  function clearError(){if(state.checkoutBlocked||state.economics?.ok!==true||!errorEl)return;errorEl.hidden=true;errorEl.textContent=''}
  function updateBusy(){
    const busy=state.pendingOps>0||state.draining||state.desired.size>0;if(busy)raiz.setAttribute('aria-busy','true');else raiz.removeAttribute('aria-busy');
    // "Vacío" se mide en unidades del pedido: un carrito con solo el seguro de envío no habilita el checkout.
    const empty=!state.cart||!Array.isArray(state.cart.items)||(PROT_VARIANT>0?unidadesCliente(state.cart):(Number(state.cart.item_count)||0))===0;cta.disabled=busy||empty||state.checkoutBlocked;
  }
  function beginBusy(){state.pendingOps+=1;updateBusy();let done=false;return()=>{if(done)return;done=true;state.pendingOps=Math.max(0,state.pendingOps-1);updateBusy()}}
  function invalidateReads(){state.readSeq+=1;if(state.refreshController){try{state.refreshController.abort()}catch{}state.refreshController=null}}
  async function parseError(resp,fallback='No pudimos actualizar el carrito.'){
    try{const j=await resp.json();return j.description||j.message||fallback}catch{return fallback}
  }
  function serialize(task,{accept=()=>true}={}){
    const wrapped=async()=>{
      invalidateReads();
      try{
        const result=await task();
        const cart=Array.isArray(result?.cart?.items)?result.cart:(Array.isArray(result?.items)&&result.item_count!=null?result:null);
        if(cart&&accept()&&!cart.items.some(it=>it.__provisional))state.confirmedCart=cart;
        return result;
      }finally{state.mutationRevision+=1}
    };
    const run=mutationChain.then(wrapped,wrapped);mutationChain=run.catch(()=>{});return run;
  }

  function bundleLineMeta(it){
    const props=it?.properties||{},role=String(props._tdm_bundle_role||'');
    const attached=role==='gift'||role==='upsell';
    return{
      attached,
      role,
      optional:Object.prototype.hasOwnProperty.call(props,'_tdm_bundle_optional')?String(props._tdm_bundle_optional)==='true':true,
      expectedQty:Math.max(1,Number(props._tdm_bundle_extra_qty)||Number(it?.quantity)||1),
      tier:Math.max(1,Number(props._tdm_bundle_tier)||1),
      token:String(props._tdm_bundle_token||'')
    };
  }
  let cremaComparePrices=[];
  try{cremaComparePrices=JSON.parse(raiz.dataset.cremaComparePrices||'[]')}catch{}
  function referenceLinePrice(it){
    const actual=Math.max(0,Number(it.final_line_price)||0),original=Math.max(actual,Number(it.original_line_price)||0);
    const qty=Math.max(0,Number(it.quantity)||0),id=Number(it.variant_id||it.id);
    let compare=Number(cremaComparePrices.find(v=>Number(v.id)===id)?.compare)||0;
    return Math.max(original,compare*qty);
  }
  function referenceSavings(cart){
    const extra=(cart.items||[]).reduce((sum,it)=>sum+Math.max(0,referenceLinePrice(it)-Math.max(Number(it.original_line_price)||0,Number(it.final_line_price)||0)),0);
    return {extra,total:discountCents(cart)+extra};
  }
  function pintarLinea(it,lineIndex){
    const original=referenceLinePrice(it),actual=Number(it.final_line_price)||0;
    const appliedDiscount=Math.max(0,(Number(it.original_line_price)||0)-actual);
    const pctOff=original>actual&&original>0?Math.round((original-actual)/original*100):0;
    const variante=(it.variant_title&&it.variant_title!=='Default Title')?it.variant_title:'';
    const id=identity(it),img=it.image?String(it.image).split('?')[0]+'?width=192':'';
    const qr=quantityRule(it),qty=Math.max(0,Number(it.quantity)||0),atMax=qr.max>0&&qty>=qr.max,meta=bundleLineMeta(it);
    const removeControl=meta.attached&&!meta.optional
      ?'<span class="smc-extra-fijo" aria-label="Incluido en el bundle">Incluido</span>'
      :`<button type="button" class="smc-quitar" data-smc-quitar aria-label="Quitar ${esc(it.product_title)}"></button>`;
    const qtyControl=meta.attached
      ?`<div class="smc-cant smc-cant--locked" aria-label="Cantidad incluida: ${qty}"><span class="smc-cant__locked">x${qty}</span></div>`
      :`<div class="smc-cant"><button type="button" class="smc-cant__b smc-cant__b--menos" data-smc-menos aria-label="Restar cantidad">${SVG_MENOS}</button><input type="number" value="${qty}" min="0" step="${qr.increment}" ${qr.max>0?`max="${qr.max}"`:''} inputmode="numeric" data-smc-input aria-label="Cantidad de ${esc(it.product_title)}"><button type="button" class="smc-cant__b smc-cant__b--mas" data-smc-mas aria-label="Sumar cantidad" ${atMax?'disabled':''}>${SVG_MAS}</button></div>`;
    return `<div class="smc-linea${meta.attached?' smc-linea--extra':''}${it.__provisional?' smc-linea--provisional':''}" data-key="${esc(it.key)}"${it.__provisional?' data-smc-provisional aria-busy="true"':''} data-line="${Number(lineIndex)+1}" data-smc-id="${esc(id)}" data-variant-id="${Number(it.variant_id)||0}" data-smc-min="${qr.min}" data-smc-increment="${qr.increment}" data-smc-max="${qr.max}"${meta.attached?` data-smc-bundle-extra="true" data-smc-extra-optional="${meta.optional?'true':'false'}"`:''}>
      <div class="smc-linea__media">${img?`<img src="${esc(img)}" alt="" width="80" height="80" loading="${(Number(lineIndex)||0)<3?'eager':'lazy'}" decoding="async">`:''}</div>
      <div class="smc-linea__info">
        <div class="smc-linea__izq">
          <a class="smc-linea__t" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${variante?`<p class="smc-linea__var">${esc(variante)}</p>`:''}
          <div class="smc-linea__precios"><span class="smc-linea__actual">${corto(actual)}</span>${original>actual?`<span class="smc-linea__tachado">${corto(original)}</span>`:''}${pctOff>0?`<span class="smc-linea__off">${pctOff}% OFF</span>`:''}</div>
          ${qty>1?`<p class="smc-linea__unit">${unitario(actual,qty)} C/U</p>`:''}
          ${esPackPies(it)&&appliedDiscount>0&&!it.__provisional?`<p class="smc-linea__unit" data-smc-applied-discount>Descuento aplicado: -${corto(appliedDiscount)}</p>`:''}
        </div>
        <div class="smc-linea__der">${removeControl}${qtyControl}</div>
      </div>
    </div>`;
  }

  function syncBadges(cart){
    // Sin el seguro de envío: el globo del carrito y el del header cuentan unidades del pedido, no servicios.
    const count=PROT_VARIANT>0?unidadesCliente(cart):Math.max(0,Number(cart?.item_count)||0);
    document.querySelectorAll('.sm-hd__count,[data-cart-count]').forEach(n=>{
      n.textContent=String(count);
      n.style.display=count>0?'':'none';
      n.setAttribute('aria-hidden',count>0?'false':'true');
    });
    // Horizon native header bubble. Our drawer replaces <theme-drawer id="cart-drawer">,
    // so the native section renderer cannot be trusted to refresh this count for custom Ajax calls.
    document.querySelectorAll('.cart-bubble').forEach(b=>{
      b.classList.toggle('visually-hidden',count<=0);
      if(count<=99)b.setAttribute('data-maintain-ratio','');else b.removeAttribute('data-maintain-ratio');
      const n=b.querySelector('[data-testid="cart-bubble"]');
      if(n){n.textContent=count>99?'99+':String(count);n.classList.toggle('hidden',count<=0)}
    });
    document.querySelectorAll('[data-tdm-cart-trigger]').forEach(t=>t.setAttribute('aria-label',`Carrito, ${count} ${count===1?'artículo':'artículos'}`));
  }
  function applyOptimistic(){
    const rows=$$('[data-smc-id]'),byId=new Map(rows.map(row=>[row.dataset.smcId,row]));
    state.desired.forEach((qty,id)=>{
      const fila=byId.get(id);if(!fila)return;
      fila.dataset.cargando='1';const inp=$('[data-smc-input]',fila);if(inp)inp.value=String(qty);
    });
    syncRemovalControls(rows);
  }
  function syncRemovalControls(rows=$$('[data-smc-id]')){
    rows.forEach(fila=>{
      const locked=state.removing.has(fila.dataset.smcId);
      if(locked)fila.dataset.smcRemoving='1';else delete fila.dataset.smcRemoving;
      $$('[data-smc-input],button[data-smc-menos],button[data-smc-mas],button[data-smc-quitar]',fila).forEach(control=>{
        if(locked){if(!removalControlLocks.has(control))removalControlLocks.set(control,control.disabled);control.disabled=true}
        else if(removalControlLocks.has(control)){control.disabled=removalControlLocks.get(control);removalControlLocks.delete(control)}
      });
    });
  }
  // ---------- escalones de beneficio ----------
  // La pista va del centro de la primera columna al de la última: con 3 columnas, del 16.666% al 83.333%,
  // o sea un ancho útil del 66.666%. El relleno se expresa como porcentaje de ese tramo.
  const ESC_TRAMO=66.666;
  function pintarEscalones(cart){
    if(!escalones)return;
    const qty=unidadesEscalera(cart);
    if(!TIERS.length||qty<=0){escalones.hidden=true;return}
    escalones.hidden=false;
    let alcanzados=0;
    TIERS.forEach((t,i)=>{
      const col=$(`[data-smc-esc-item="${i+1}"]`);if(!col)return;
      const on=qty>=t.qty;if(on)alcanzados=i+1;
      col.dataset.on=on?'true':'false';col.removeAttribute('data-actual');
    });
    if(alcanzados>0){const actual=$(`[data-smc-esc-item="${alcanzados}"]`);if(actual)actual.dataset.actual='true'}
    const pasos=TIERS.length-1;
    const pct=pasos>0?Math.min(100,Math.max(0,((alcanzados-1)/pasos)*100)):0;
    if(escBarra)escBarra.style.width=(ESC_TRAMO*pct/100).toFixed(3)+'%';
    if(!escFalta)return;
    const next=tierSiguiente(qty);
    if(next&&ESC_FALTA){
      escFalta.innerHTML=esc(ESC_FALTA).replace('[N]',`<b>${Math.max(1,next.qty-qty)}</b>`).replace('[BENEFICIO]',`<b>${esc(next.label)}</b>`);
      escFalta.hidden=false;
    }else if(!next&&ESC_COMPLETO){escFalta.textContent=ESC_COMPLETO;escFalta.hidden=false}
    else escFalta.hidden=true;
  }

  // ---------- tarjeta del siguiente escalón ----------
  function pintarNext(cart){
    if(!nextCaja)return;
    const qty=unidadesEscalera(cart),next=tierSiguiente(qty);
    if(!TIERS.length||qty<=0||!next||!lineasEscalera(cart).length){nextCaja.hidden=true;return}
    const faltan=Math.max(1,next.qty-qty),diferencia=Math.max(0,next.totalCents-totalEscalera(cart));
    // Todo texto vaciado en el editor oculta su propio elemento, sin dejar huecos.
    if(nextTitulo){const t=NEXT_TITULO.replace('[N]',String(faltan)).replace('[MONTO]',corto(diferencia));nextTitulo.textContent=t;nextTitulo.hidden=!t}
    if(nextSub){const t=NEXT_SUB.replace('[QTY]',String(next.qty)).replace('[BENEFICIO]',next.label).replace('[TOTAL]',corto(next.totalCents));nextSub.textContent=t;nextSub.hidden=!t}
    // El precio por unidad del escalón siguiente: es la comparación con la que se decide un pack.
    if(nextUnit){const u=NEXT_UNIT.replace('[UNITARIO]',unitario(next.totalCents,next.qty)).replace('[QTY]',String(next.qty));nextUnit.textContent=u;nextUnit.hidden=!u||next.totalCents<=0}
    if(nextBtn){const t=NEXT_CTA.replace('[QTY]',String(next.qty));nextBtn.textContent=t;nextBtn.hidden=!t;nextBtn.dataset.smcTarget=String(next.qty)}
    // Si se vaciaron todos los textos de la tarjeta, no queda nada que mostrar y se oculta entera.
    const hayContenido=[nextTitulo,nextSub,nextUnit,nextBtn].some(el=>el&&!el.hidden&&el.textContent.trim())||!!$('.smc-next__k');
    nextCaja.hidden=!hayContenido;
  }
  function subirATier(target){
    const cart=state.cart,objetivo=Math.max(0,Math.floor(Number(target)||0));if(!cart||!objetivo)return;
    const lineas=lineasEscalera(cart);if(!lineas.length||!TIERS.some(t=>t.qty===objetivo))return;
    const delta=objetivo-unidadesEscalera(cart);if(delta<=0)return;
    // Se suma sobre la línea con más unidades: con un solo producto es la única, y con varias
    // evita repartir el salto y que ninguna llegue al escalón.
    const base=lineas.slice().sort((a,b)=>(Number(b.quantity)||0)-(Number(a.quantity)||0))[0];
    queueQty(identity(base),(Number(base.quantity)||0)+delta);
  }

  // ---------- envío protegido ----------
  let protOcupado=false;
  function pintarProteccion(cart){
    if(!prot)return;
    const qty=unidadesCliente(cart);
    if(!PROT_VARIANT||qty<=0){prot.hidden=true;return}
    prot.hidden=false;
    const linea=lineaProt(cart),activo=!!linea;
    prot.dataset.on=activo?'true':'false';
    if(protSw)protSw.setAttribute('aria-checked',activo?'true':'false');
    if(protPrecio)protPrecio.textContent=corto(linea?(Number(linea.final_line_price)||PROT_PRICE):PROT_PRICE);
  }
  // Si el cliente vacía el pedido y queda solo el seguro, se quita solo: cobrar un seguro sin envío no tiene sentido.
  function limpiarProteccionHuerfana(cart){
    if(!PROT_VARIANT||protOcupado)return false;
    const linea=lineaProt(cart);
    if(!linea||unidadesCliente(cart)>0)return false;
    queueQty(identity(linea),0);return true;
  }
  async function alternarProteccion(){
    if(protOcupado||!PROT_VARIANT)return;
    const cart=state.cart;if(!cart)return;
    const linea=lineaProt(cart),encender=!linea;
    protOcupado=true;if(protSw){protSw.disabled=true;protSw.setAttribute('aria-checked',encender?'true':'false')}
    if(prot)prot.dataset.on=encender?'true':'false';
    try{
      if(encender)await addItems([{id:PROT_VARIANT,quantity:1}],{open:false});
      else queueQty(identity(linea),0);
    }catch(e){console.error('[TDM cart envío protegido]',e);pintarProteccion(state.cart||cart)}
    finally{protOcupado=false;if(protSw)protSw.disabled=false}
  }

  // ---------- regalo y sellos ----------
  // El regalo y los sellos solo tienen sentido con algo en el carrito; con el carrito vacío
  // llenarían la pantalla de promesas sobre una compra que todavía no existe.
  function pintarExtras(cart){
    const qty=unidadesCliente(cart);
    if(extras)extras.hidden=qty<=0;
    // The inherited acne guide belongs to CLEAR, including mixed carts; PIES does not include it.
    if(regalo)regalo.hidden=!lineasEscalera(cart).some(esClear);
  }

  // Firma barata del estado visible: si coincide con lo último pintado, abrir el cajón no reconstruye nada.
  const cartSignature=cart=>`${cart.item_count||0}|${cart.total_price||0}|${cart.original_total_price||0}|${cart.total_discount||0}|${cart.items.map(it=>`${it.key}:${it.quantity}:${it.final_line_price}`).join(',')}`;
  function render(cart,{announceChange=false,markFresh=true,force=false}={}){
    if(!cart||!Array.isArray(cart.items))return;
    state.cart=cart;if(markFresh)state.fetchedAt=Date.now();
    if(!cart.items.some(it=>it.__provisional))state.confirmedCart=cart;
    // Validation is independent of the DOM cache: a newly loaded/failed validator must take effect.
    const econ=revalidateEconomics(cart);
    const sig=cartSignature(cart);
    if(!force&&sig===state.paintedSig&&!state.desired.size&&!state.pendingOps){syncBadges(cart);return econ}
    const visibles=lineasCliente(cart),shipping=shippingStatus(cart);
    state.paintedSig=sig;globo.textContent=String(PROT_VARIANT>0?unidadesCliente(cart):(cart.item_count||0));
    if(!visibles.length){lineas.innerHTML=EMPTY?'<p class="smc-vacio">'+esc(EMPTY)+'</p>':'';totales.innerHTML='';ahorro.hidden=true}
    else{
      lineas.innerHTML=visibles.map(pintarLinea).join('');
      const reference=referenceSavings(cart),hasPies=visibles.some(esPackPies);
      const desc=hasPies?discountCents(cart):reference.total;
      // Etiqueta vacía en el editor = esa fila no se dibuja.
      const shippingRow='<div class="smc-totales__fila smc-totales__fila--envio"><span>Envío</span><span class="smc-totales__valor">Se calcula al finalizar la compra</span></div>';
      totales.innerHTML=(desc>0&&LABEL_DISCOUNT?`<div class="smc-totales__fila smc-totales__fila--desc"><span>${esc(LABEL_DISCOUNT)}</span><span class="smc-totales__valor">- ${conMoneda(desc)}</span></div>`:'')+shippingRow+(LABEL_TOTAL?`<div class="smc-totales__fila smc-totales__fila--total"><span>${esc(LABEL_TOTAL)}</span><span class="smc-totales__valor">${conMoneda(merchandiseTotal(cart))}</span></div>`:'');
      const savings=reference.total;
      ahorro.hidden=savings<=0||!SAVINGS;if(savings>0)ahorroTxt.textContent=hasPies&&reference.extra>0?`Ahorro total vs. precio anterior: ${largo(savings)}`:SAVINGS.replace('[MONTO]',largo(savings));
    }
    // Shopify determines delivery rates in checkout; a merchandise subtotal cannot confirm free shipping.
    envioTxt.textContent='';
    barra.style.transform='scaleX(0)';
    if(envio){envio.dataset.unlocked='false';envio.hidden=true;}
    pintarEscalones(cart);pintarNext(cart);pintarProteccion(cart);pintarExtras(cart);limpiarProteccionHuerfana(cart);
    syncBadges(cart);applyOptimistic();
    document.dispatchEvent(new CustomEvent('tdm:cart:updated',{detail:{cart}}));
    if(announceChange)announce(`Carrito actualizado. ${cart.item_count||0} unidades. Total ${conMoneda(merchandiseTotal(cart))}.`);
    return econ;
  }

  async function getCart({signal}={}){const r=await fetch(route('cart.js'),{headers:{Accept:'application/json'},credentials:'same-origin',signal});if(!r.ok)throw new Error(await parseError(r,'No pudimos cargar el carrito.'));return r.json()}
  let lastClearRepriceAttempt='';
  function staleClearPricing(cart){
    if(!Array.isArray(cart?.items)||cart.items.some(it=>it.__provisional))return false;
    const pricing=window.DERMOVACartPricing;if(typeof pricing?.validate!=='function')return false;
    try{return pricing.validate(cart).checks?.some(c=>Number(c.variantId)===52678402539813&&!c.ok&&!c.provisional)===true}catch{return false}
  }
  async function reconcileClearPricing(cart,read=null){
    if(!staleClearPricing(cart)||state.desired.size||state.draining)return cart;
    let ownsRead=()=>false;
    return serialize(async()=>{
      const seq=state.readSeq,revision=state.mutationRevision;
      ownsRead=()=>seq===state.readSeq&&revision===state.mutationRevision&&!state.desired.size&&!state.draining;
      // serialize invalidates its own read and increments the revision on exit.
      if(read){read.seq=seq;read.revision=revision+1}
      if(state.desired.size||state.draining)return null;
      // A fresh read inside the mutation queue prevents restoring an old quantity.
      const current=await getCart();if(!ownsRead())return null;if(!staleClearPricing(current))return current;
      const lines=current.items.filter(it=>Number(it.variant_id||it.id)===52678402539813);
      if(!lines.length||lines.some(it=>!it.key||Number(it.quantity)<1))return current;
      const signature=JSON.stringify(lines.map(it=>[it.key,it.quantity,it.original_line_price,it.final_line_price]));
      if(signature===lastClearRepriceAttempt)return current;
      lastClearRepriceAttempt=signature;
      const updates=Object.fromEntries(lines.map(it=>[it.key,Number(it.quantity)]));
      // Same quantities and line keys: keep properties, gifts and other products intact.
      try{
        const r=await fetch(route('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({updates})});
        if(!r.ok)throw new Error(await parseError(r,'No pudimos actualizar el precio vigente. Volvé a abrir el carrito.'));
        const updated=await r.json();
        if(!ownsRead()){lastClearRepriceAttempt='';return null}
        if(!Array.isArray(updated?.items)||updated.items.some(it=>it.__provisional))throw new Error('No pudimos confirmar el precio vigente. Volvé a abrir el carrito.');
        return updated;
      }catch(error){lastClearRepriceAttempt='';throw error}
    },{accept:()=>ownsRead()});
  }
  async function refresh({silent=false}={}){
    const read={seq:++state.readSeq,revision:state.mutationRevision};
    const ownsRead=()=>read.seq===state.readSeq&&read.revision===state.mutationRevision;
    if(state.refreshController){try{state.refreshController.abort()}catch{}}
    const controller=typeof AbortController==='function'?new AbortController():null;state.refreshController=controller;const releaseBusy=beginBusy();
    try{
      let cart=await getCart({signal:controller?.signal});
      if(!ownsRead())return cart;
      cart=await reconcileClearPricing(cart,read);
      if(!cart||!ownsRead()||state.desired.size||state.draining)return state.cart||cart;
      const econ=render(cart);if(econ?.ok)clearError();return cart;
    }catch(e){
      if(e?.name==='AbortError'||!ownsRead())return state.cart;
      if(!silent)showError(e.message);throw e;
    }finally{
      if(state.refreshController===controller)state.refreshController=null;releaseBusy();
    }
  }

  function findItem(cart,id){return cart?.items?.find(it=>identity(it)===id)||null}
  function findItemEntry(cart,id){const index=cart?.items?.findIndex(it=>identity(it)===id)??-1;return index>=0?{item:cart.items[index],line:index+1}:null}
  function failHardEconomics(reason,error){
    if(error)console.warn('[TDM cart] validator',error);
    return{required:true,ok:false,reason};
  }
  function validateEconomics(cart){
    const pricing=window.DERMOVACartPricing,legacy=window.TDMProductSync;
    const knownProduct=(cart?.items||[]).some(it=>[53904624812325,52678402539813,53949689594149].includes(Number(it.variant_id||it.id)));
    let required=knownProduct;
    let globalCheck={required:false,ok:true,reason:'validator-unavailable'},legacyCheck={required:false,ok:true,reason:'legacy-unavailable'};
    const failed=(reason,error,origin='global')=>{
      const failure=required||state.economicsRequired?failHardEconomics(reason,error):{required:false,ok:false,reason};
      return{...failure,global:origin==='global'?failure:globalCheck,legacy:origin==='legacy'?failure:legacyCheck};
    };
    try{if(typeof pricing?.requires==='function')required=!!pricing.requires(cart)||required}
    catch(error){return failed('validator-requirements-error',error)}
    if(typeof pricing?.validate==='function'){
      try{
        globalCheck=pricing.validate(cart);
        if(globalCheck?.required===true)required=true;
        if(!globalCheck||typeof globalCheck.required!=='boolean'||typeof globalCheck.ok!=='boolean')return failed('validator-invalid-result');
        globalCheck={...globalCheck,required:required||globalCheck.required};
      }catch(error){return failed('validator-error',error)}
    }else if(required||state.economics?.global?.required)return failed('validator-unavailable');
    if(typeof legacy?.validateCartEconomics==='function'){
      try{
        const result=legacy.validateCartEconomics(cart);
        if(result?.required===true)required=true;
        if(!result||typeof result.required!=='boolean'||typeof result.ok!=='boolean')return failed('legacy-invalid-result',undefined,'legacy');
        // Global rules own DERMOVA primary prices; keep the legacy attached-extra checks.
        legacyCheck=globalCheck.required?(result.attached?{...result.attached,required:result.required&&result.attached.required}:{required:false,ok:true,reason:'no-legacy-extras'}):result;
        if(typeof legacyCheck.required!=='boolean'||typeof legacyCheck.ok!=='boolean')return failed('legacy-invalid-extras',undefined,'legacy');
      }catch(error){return failed('legacy-validator-error',error,'legacy')}
    }else if(state.economics?.legacy?.required)return failed('legacy-validator-unavailable',undefined,'legacy');
    const checks=[globalCheck,legacyCheck],ok=checks.every(check=>check.ok),needsValidation=checks.some(check=>check.required);
    return{required:needsValidation,ok,reason:ok?'ok':(checks.find(check=>check.required&&!check.ok)||checks.find(check=>!check.ok)).reason,global:globalCheck,legacy:legacyCheck};
  }
  function revalidateEconomics(cart=state.cart){
    const wasBlocked=state.checkoutBlocked;
    const econ=validateEconomics(cart);state.economics=econ;state.economicsRequired=!!econ.required;
    state.checkoutBlocked=!!(econ.required&&!econ.ok);updateBusy();
    if(state.checkoutBlocked&&!cart?.items?.some(it=>it.__provisional))showError('No pudimos validar el descuento actual del carrito. El checkout queda bloqueado hasta reconciliar el precio con Shopify.');
    else if(wasBlocked&&econ.ok)clearError();
    return econ;
  }
  async function postChange(target,qty){
    const payload={quantity:Math.max(0,Number(qty)||0)};
    if(Number(target?.line)>0)payload.line=Number(target.line);else if(target?.key)payload.id=String(target.key);else throw new Error('No encontramos la línea actual del carrito.');
    const r=await fetch(route('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify(payload)});
    if(!r.ok)throw new Error(await parseError(r));return r.json();
  }

  function attachedExtraUpdates(cart){
    const groups=new Map();
    for(const it of cart?.items||[]){
      const props=it?.properties||{},token=String(props._tdm_bundle_token||''),role=String(props._tdm_bundle_role||'');
      if(!token)continue;
      let group=groups.get(token);if(!group){group={primaryQty:0,extras:[]};groups.set(token,group)}
      if(role==='primary')group.primaryQty+=Math.max(0,Number(it.quantity)||0);
      else if(role==='upsell'||role==='gift')group.extras.push({key:it.key,qty:Math.max(0,Number(it.quantity)||0),expectedQty:Math.max(1,Number(props._tdm_bundle_extra_qty)||Number(it.quantity)||1),tier:Math.max(1,Number(props._tdm_bundle_tier)||1)});
    }
    const updates={};
    groups.forEach(group=>group.extras.forEach(extra=>{
      if(group.primaryQty<extra.tier&&extra.key)updates[extra.key]=0;
      else if(group.primaryQty>=extra.tier&&extra.key&&extra.qty!==extra.expectedQty)updates[extra.key]=extra.expectedQty;
    }));
    return updates;
  }

  async function reconcileAttachedExtras(cart){
    const updates=attachedExtraUpdates(cart);if(!Object.keys(updates).length)return cart;
    const r=await fetch(route('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({updates})});
    if(!r.ok)throw new Error(await parseError(r,'No pudimos reconciliar el producto extra del bundle.'));
    return r.json();
  }

  function scheduleDrain(){clearTimeout(state.drainTimer);state.drainTimer=setTimeout(()=>void drainDesired(),DEBOUNCE_QTY)}
  function queueQty(id,qty){
    if(state.removing.has(id))return 0;
    const it=findItem(state.confirmedCart||state.cart,id);qty=normalizeQty(qty,it);
    state.desired.set(id,qty);if(qty===0)state.removing.add(id);
    updateBusy();clearError();applyOptimistic();scheduleDrain();return qty;
  }
  async function drainDesired(){
    if(state.draining||!state.desired.size)return;state.draining=true;const releaseBusy=beginBusy();
    try{
      while(state.desired.size){
        const [id,target]=state.desired.entries().next().value;state.desired.delete(id);
        try{
          const cart=await serialize(async()=>{
            // Resolve the index only after preceding mutations settle, against confirmed lines.
            let before=state.confirmedCart||await getCart(),entry=findItemEntry(before,id);
            if(!entry){before=await getCart();state.confirmedCart=before;entry=findItemEntry(before,id)}
            if(!entry){if(target===0)return before;throw new Error('La línea cambió mientras actualizábamos el carrito. Revisá la cantidad antes de reintentar.')}
            let changed;
            try{changed=await postChange(entry,target)}
            catch(firstError){
              const freshCart=await getCart(),retry=findItemEntry(freshCart,id);state.confirmedCart=freshCart;
              if(!retry){if(target===0)return freshCart;throw firstError}
              changed=await postChange(retry,target);
            }
            // Keep the primary mutation and attached-extra reconciliation in one transaction.
            return reconcileAttachedExtras(changed);
          });
          const current=state.confirmedCart||cart;
          const econ=render(current,{announceChange:true});
          if(target>0&&econ?.required&&!econ.ok){
            await new Promise(resolve=>setTimeout(resolve,DISCOUNT_RECONCILE_MS));
            try{const reconciled=await serialize(()=>getCart());render(state.confirmedCart||reconciled,{announceChange:false})}catch{}
          }
          clearError();
        }finally{
          if(target===0){state.removing.delete(id);syncRemovalControls()}
        }
      }
    }catch(e){console.error('[TDM cart quantity]',e);try{const recovered=await serialize(()=>getCart());render(state.confirmedCart||recovered)}catch{}showError(e.message||'No pudimos actualizar la cantidad.')}
    finally{state.draining=false;releaseBusy();if(state.desired.size)scheduleDrain()}
  }

  // Agregar al carrito optimista: el cajón se abre YA con las líneas dibujadas desde los datos de la página,
  // mientras el POST viaja a Shopify. confirm(cart) pinta el carrito real; cancel() vuelve al estado anterior.
  function buildOptimisticCart(base,lines,stamp=Date.now()){
    const items=(base.items||[]).map(it=>({...it})),src=window.TDMProductSync?.getSource?.();
    const mergeUnits=src?.packMode==='quantity'&&Number(src?.baseVariantId)>0;
    const sum=(arr,f)=>arr.reduce((s,x)=>s+(Number(f(x))||0),0);
    lines.forEach((line,index)=>{
      const merge=mergeUnits&&Number(line.variant_id||line.id)===Number(src.baseVariantId)?items.find(it=>identity(it)===identity(line)):null;
      if(merge){
        merge.quantity=Number(merge.quantity||0)+Number(line.quantity||0);
        merge.final_line_price=Number(merge.final_line_price||0)+Number(line.final_line_price||0);
        merge.original_line_price=Number(merge.original_line_price||0)+Number(line.original_line_price||0);
        merge.__provisional=true;
      }else items.unshift({...line,key:`optimista-${stamp}-${index}`,__provisional:true});
    });
    const cart={...base,items,item_count:Number(base.item_count||0)+sum(lines,x=>x.quantity),
      total_price:Number(base.total_price||0)+sum(lines,x=>x.final_line_price),
      original_total_price:Number(base.original_total_price||0)+sum(lines,x=>x.original_line_price)};
    cart.items_subtotal_price=Number(base.items_subtotal_price??base.total_price??0)+sum(lines,x=>x.final_line_price);
    cart.total_discount=Math.max(0,cart.original_total_price-merchandiseTotal(cart));
    try{return window.DERMOVACartPricing?.preview?.(cart)||window.TDMProductSync?.repriceQuantityPreview?.(cart)||cart}
    catch(error){console.warn('[TDM cart] preview',error);return cart}
  }
  function openOptimistic(lines){
    if(!Array.isArray(lines)||!lines.length)return null;
    const base=state.cart&&Array.isArray(state.cart.items)?state.cart:{items:[],item_count:0,total_price:0,original_total_price:0,total_discount:0};
    const cart=buildOptimisticCart(base,lines);
    const real=base,release=beginBusy();let done=false;
    raiz.dataset.smcOptimista='1';clearError();
    render(cart,{markFresh:false,force:true});openDrawer(null,{refresh:false,paint:false});
    const finish=()=>{if(done)return false;done=true;delete raiz.dataset.smcOptimista;release();return true};
    return {
      confirm(realCart){if(!finish())return;if(realCart&&Array.isArray(realCart.items))render(realCart,{announceChange:true,force:true});else refresh({silent:true}).catch(()=>{});if(!state.checkoutBlocked)clearError()},
      cancel(){if(!finish())return;render(real,{markFresh:false,force:true});closeDrawer()}
    };
  }
  async function addItems(items,{open=true}={}){
    const clean=(Array.isArray(items)?items:[]).map(x=>({...x,id:Number(x.id),quantity:Math.max(1,Number(x.quantity)||1)})).filter(x=>x.id);
    if(!clean.length)throw new Error('No encontramos una variante válida para agregar.');
    clearError();const releaseBusy=beginBusy();if(open)openDrawer(state.cart,{refresh:false});
    try{
      const cart=await serialize(async()=>{
        const r=await fetch(route('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({items:clean,sections:'cart-drawer-section',sections_url:window.location?.pathname||'/'})});
        if(!r.ok)throw new Error(await parseError(r,'No pudimos agregar el producto.'));
        const added=await r.json();return cartFromAddResponse(added)||await getCart();
      });
      render(state.confirmedCart||cart,{announceChange:true});if(!state.checkoutBlocked)clearError();return cart;
    }catch(e){showError(e.message);throw e}
    finally{releaseBusy()}
  }

  function setBackgroundInert(on){const page=document.querySelector('.page-wrapper');if(page){if(on)page.setAttribute('inert','');else page.removeAttribute('inert')}}
  function lockScroll(on){
    if(on){state.scrollY=window.scrollY||0;document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';document.body.style.overscrollBehavior='none'}
    else{document.documentElement.style.overflow='';document.body.style.overflow='';document.body.style.overscrollBehavior=''}
  }
  const adjustHeight=()=>{if(!alive()||!raiz.dataset.abierto)return;const vv=window.visualViewport;raiz.style.height=Math.round(vv?vv.height:window.innerHeight)+'px'};
  if(window.visualViewport){visualViewport.addEventListener('resize',adjustHeight,{passive:true});visualViewport.addEventListener('scroll',adjustHeight,{passive:true})}
  window.addEventListener('resize',adjustHeight,{passive:true});window.addEventListener('orientationchange',()=>setTimeout(adjustHeight,250));

  function focusables(){return $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',panel).filter(el=>!el.hidden&&el.getClientRects().length)}
  function syncTriggerExpanded(open){document.querySelectorAll('[data-tdm-cart-trigger]').forEach(t=>t.setAttribute('aria-expanded',open?'true':'false'))}
  // El deslizamiento del panel cuesta ~3 ms; marcar la página de fondo como inert y bloquear el scroll
  // obligan a recalcular toda la página (~110 ms en un celular medio). Se hacen cuando el panel ya llegó,
  // así el primer frame del cajón sale en la siguiente pintura.
  const SLIDE_MS=260,reducedMotion=()=>window.matchMedia?.('(prefers-reduced-motion: reduce)').matches===true;
  function cancelSlide(){if(state.slide){panel.removeEventListener('transitionend',state.slide.once);clearTimeout(state.slide.timer);state.slide=null}}
  function afterSlide(fn){
    cancelSlide();
    if(reducedMotion()){requestAnimationFrame(fn);return}
    const once=e=>{if(e.target!==panel||e.propertyName!=='transform')return;cancelSlide();fn()};
    const timer=setTimeout(()=>{cancelSlide();fn()},SLIDE_MS+80);
    state.slide={once,timer};panel.addEventListener('transitionend',once);
  }
  function settleOpen(){
    if(!alive()||!raiz.dataset.abierto||state.settled)return;
    state.settled=true;setBackgroundInert(true);lockScroll(true);adjustHeight();
    ($('.smc-cerrar')||panel)?.focus({preventScroll:true});
  }
  function openDrawer(cartPreloaded=null,{refresh:shouldRefresh=true,paint:shouldPaint=true}={}){
    const wasOpen=!!raiz.dataset.abierto;
    if(!wasOpen){state.lastFocus=document.activeElement;state.settled=false}
    raiz.dataset.abierto='1';raiz.setAttribute('aria-hidden','false');syncTriggerExpanded(true);
    if(shouldPaint&&cartPreloaded&&Array.isArray(cartPreloaded.items)){render(cartPreloaded);if(!state.checkoutBlocked)clearError();if(shouldRefresh&&state.checkoutBlocked)refresh({silent:true}).catch(()=>{})}
    else if(shouldPaint&&state.cart&&Array.isArray(state.cart.items)){render(state.cart,{markFresh:false});if(!state.checkoutBlocked)clearError();if(shouldRefresh&&(!fresh()||state.checkoutBlocked))refresh({silent:true}).catch(()=>{})}
    else if(shouldPaint&&shouldRefresh){announce('Actualizando carrito…');refresh().catch(()=>{})}
    if(!wasOpen)afterSlide(settleOpen);else if(state.settled)adjustHeight();
  }
  function closeDrawer(){
    if(!raiz.dataset.abierto)return;
    cancelSlide();
    delete raiz.dataset.abierto;raiz.setAttribute('aria-hidden','true');syncTriggerExpanded(false);clearError();updateBusy();
    const release=()=>{if(raiz.dataset.abierto)return;raiz.style.height='';setBackgroundInert(false);lockScroll(false);state.settled=false;if(state.lastFocus?.focus)state.lastFocus.focus({preventScroll:true})};
    if(state.settled)afterSlide(release);else release();
  }

  function cartFromInitialDOM(){
    const el=document.querySelector('script[data-tdm-initial-cart-state]');if(!el)return null;
    try{const cart=JSON.parse(el.textContent||'');return cart&&Array.isArray(cart.items)?cart:null}catch(e){console.warn('[TDM cart initial state]',e);return null}
  }
  const initialCart=cartFromInitialDOM();
  if(initialCart){state.cart=initialCart;state.confirmedCart=initialCart;state.fetchedAt=Date.now();syncBadges(initialCart)}
  revalidateEconomics();
  const checkoutForm=cta?.closest('form');
  raiz.addEventListener('submit',e=>{
    if(e.target!==checkoutForm)return;
    revalidateEconomics();
    if(!cta.disabled)return;
    e.preventDefault();e.stopImmediatePropagation();
    if(state.checkoutBlocked)return;
    announce(state.pendingOps>0||state.draining||state.desired.size?'Estamos actualizando el carrito. Esperá a que termine antes de finalizar la compra.':EMPTY);
  },true);
  document.addEventListener('tdm:cart:validator-ready',()=>{if(!alive())return;const econ=revalidateEconomics();if(econ.ok)clearError()});
  // Pre-pintado en tiempo ocioso: las líneas, totales e imágenes quedan listas antes del primer clic,
  // así la primera apertura cuesta lo mismo que las siguientes (solo el deslizamiento).
  if(initialCart){const idle=window.requestIdleCallback||(fn=>setTimeout(fn,1200));idle(()=>{if(alive()&&!raiz.dataset.abierto&&state.cart===initialCart&&!state.paintedSig)render(initialCart,{markFresh:false})})}
  window.addEventListener('pageshow',e=>{if(!alive()||!e.persisted)return;if(state.cart)render(state.cart,{markFresh:false});refresh({silent:true}).catch(()=>{})});

  // Bridge with Horizon's native product forms/quick-add. DERMOVA requests Ajax's full
  // discount and shipping breakdown; unrelated products can adapt a matching event directly.
  document.addEventListener('shopify:cart:lines-update',e=>{
    if(!alive())return;
    const isAdd=e.action==='add';if(isAdd&&!raiz.dataset.abierto)openDrawer(fresh()?state.cart:null,{refresh:false});
    const done=e.promise;if(!done?.then)return;
    done.then(result=>{
      if(result?.detail?.didError){if(isAdd)showError('No pudimos agregar el producto.');return}
      const cart=cartFromStandardResult(result);
      if(cart){invalidateReads();state.mutationRevision+=1;render(cart,{announceChange:true});if(!state.checkoutBlocked)clearError();updateBusy()}
      else refresh({silent:!isAdd}).catch(()=>{});
    }).catch(err=>{console.warn('[TDM cart standard event]',err);if(isAdd)showError('No pudimos actualizar el carrito.')});
  });

  document.addEventListener('click',e=>{
    if(!alive())return;
    const nativeTrigger=e.target.closest?.('[data-tdm-cart-trigger]');
    if(nativeTrigger&&!nativeTrigger.closest('.smc-raiz')&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey&&e.button===0){e.preventDefault();openDrawer();return}
    const a=e.target.closest?.('a.sm-hd__cart, a[href$="/cart"]');
    if(a&&!a.closest('.smc-raiz')&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey&&e.button===0){e.preventDefault();openDrawer();return}
    if(e.target.closest?.('[data-smc-cerrar]')){closeDrawer();return}
    const add=e.target.closest?.('[data-smc-agregar]');if(add){add.disabled=true;addItems([{id:add.dataset.smcAgregar,quantity:1}],{open:false}).catch(()=>{}).finally(()=>{add.disabled=false});return}
    const saltar=e.target.closest?.('[data-smc-next-cta-btn]');if(saltar){subirATier(saltar.dataset.smcTarget);return}
    if(e.target.closest?.('[data-smc-prot-toggle]')){void alternarProteccion();return}
    const fila=e.target.closest?.('.smc-linea');if(!fila)return;
    const id=fila.dataset.smcId,inp=$('[data-smc-input]',fila);if(!id||!inp)return;
    if(state.removing.has(id))return;
    const current=Math.max(0,Number(inp.value)||0);
    if(e.target.closest('[data-smc-quitar]')){inp.value='0';return queueQty(id,0)}
    const it=findItem(state.cart,id),qr=quantityRule(it);
    // Scope +/- to the actual buttons. The drawer root also stores icon URLs in
    // data-smc-menos/data-smc-mas, so a generic closest('[data-smc-menos]') would
    // climb to the root and incorrectly interpret a + click as a minus click.
    if(e.target.closest('button[data-smc-menos]')){const q=current<=qr.min?0:current-qr.increment;const n=queueQty(id,q);inp.value=String(n);return}
    if(e.target.closest('button[data-smc-mas]')){const q=qr.max>0?Math.min(qr.max,current+qr.increment):current+qr.increment;const n=queueQty(id,q);inp.value=String(n);return}
  });
  raiz.addEventListener('change',e=>{const inp=e.target.closest?.('[data-smc-input]');if(!inp)return;const fila=inp.closest('.smc-linea');const q=queueQty(fila.dataset.smcId,inp.value);inp.value=String(q)});
  document.addEventListener('keydown',e=>{
    if(!alive()||!raiz.dataset.abierto)return;
    if(e.key==='Escape'){e.preventDefault();closeDrawer();return}
    if(e.key!=='Tab')return;const f=focusables();if(!f.length){e.preventDefault();panel.focus();return}const first=f[0],last=f[f.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
  });

  // Editor de temas: seleccionar la sección "Carrito lateral" abre el cajón en la vista previa;
  // deseleccionarla lo cierra. Si el editor re-renderiza la sección mientras está seleccionada, se reabre.
  if(window.Shopify?.designMode){
    const sectionEl=raiz.closest('.shopify-section');
    const mine=e=>!!sectionEl&&(e.target===sectionEl||sectionEl.contains(e.target));
    document.addEventListener('shopify:section:select',e=>{if(!alive()||!mine(e))return;window.__TDM_CART_EDITOR_OPEN__=true;openDrawer(state.cart,{refresh:false})});
    document.addEventListener('shopify:section:deselect',e=>{if(!alive()||!mine(e))return;window.__TDM_CART_EDITOR_OPEN__=false;closeDrawer()});
    if(window.__TDM_CART_EDITOR_OPEN__)requestAnimationFrame(()=>{if(alive())openDrawer(state.cart,{refresh:false})});
  }

  window.smcAbrirCajon=openDrawer;window.smcCerrarCajon=closeDrawer;window.smcRefrescarCajon=refresh;window.smcAgregarItems=addItems;
  window.TDMCart={open:openDrawer,close:closeDrawer,refresh,addItems,openOptimistic,notice:msg=>{showError(msg)},getCart,cartFromAddResponse,runExclusive:serialize,invalidateReads,revalidateEconomics,get state(){return{cart:state.cart,subtotalCents:merchandiseTotal(state.cart),confirmedCart:state.confirmedCart,desired:new Map(state.desired),removing:new Set(state.removing),open:!!raiz.dataset.abierto,pendingOps:state.pendingOps,checkoutBlocked:state.checkoutBlocked,economics:state.economics,readSeq:state.readSeq,mutationRevision:state.mutationRevision}},beneficios:{tiers:()=>TIERS.slice(),unidades:()=>unidadesEscalera(state.cart),subirA:subirATier,alternarProteccion,proteccionActiva:()=>!!lineaProt(state.cart)},
    __test:{identity,merchandiseTotal,discountCents,stableObject,quantityRule,normalizeQty,cartFromSectionHTML,cartFromAddResponse,cartFromStandardResult,cartFromInitialDOM,findItemEntry,queueQty,drainDesired,render,invalidateReads,beginBusy,validateEconomics,revalidateEconomics,failHardEconomics,syncRemovalControls,bundleLineMeta,attachedExtraUpdates,reconcileAttachedExtras,esProt,esPackPies,lineasEscalera,unidadesEscalera,totalEscalera,lineasCliente,unidadesCliente,totalCliente,lineaProt,tierSiguiente,pintarEscalones,pintarNext,pintarProteccion,subirATier,limpiarProteccionHuerfana,TIERS,buildOptimisticCart}};
}

  class TdmCartDrawer extends HTMLElement{connectedCallback(){bindCart(this)}}
  if(!customElements.get('tdm-cart-drawer'))customElements.define('tdm-cart-drawer',TdmCartDrawer);
  // Compatibilidad con un markup viejo (raíz <div id="smc-cajon">).
  const legacy=document.getElementById('smc-cajon');
  if(legacy&&legacy.tagName!=='TDM-CART-DRAWER')bindCart(legacy);
})();


